import netteForms from 'nette-forms';
import {flushDateProxies, findBlockingDateProxy, reportBlockingDateProxy} from '/webpack/assets/js/datePicker/dateProxyGuard.js';
window.Nette = netteForms;

Nette.validateControlTimer = {};

Nette.validateForm = function(sender, onlyCheck) {
	var form = sender.form || sender,
		scope = false;

	Nette.formErrors = [];

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		var scopeArr = JSON.parse(form['nette-submittedBy'].getAttribute('data-nette-validation-scope') || '[]');
		if (scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			Nette.showFormErrors(form, []);
			return true;
		}
	}

	var radios = {}, i, elem;

	// A partly typed date is submitted as '' and would silently clear the value (DEVDV-676); limited to
	// type="date" so number fields keep their own :integer message. A field hidden by Nette.toggle is
	// skipped: no bubble can show there, and its '' is what the toggle intends.
	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.type !== 'date' || !elem.willValidate || !elem.validity.badInput || elem.closest('[hidden]')) {
			continue;
		}

		if (scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) {
			continue;
		}

		elem.reportValidity();
		return false;
	}

	// An edited date picker text field blocks here: the native input behind it stays valid (DEVDV-684).
	flushDateProxies(form);

	var blockingDateProxy = findBlockingDateProxy(form, sender);

	if (blockingDateProxy && !onlyCheck) {
		reportBlockingDateProxy(blockingDateProxy);
	}

	if (blockingDateProxy) {
		return false;
	}

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;

		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
			continue;
		}

		if (!Nette.validateControl(elem, null, onlyCheck) && !Nette.formErrors.length) {
			return false;
		}
		else if (!Nette.formErrors.length) {
			let $element = $(elem);
			$element.parents('smart-input').find('[data-error-message]').removeAttr();
			$element.parents('smart-input').find('smart-input-error-message').remove();
			$element.parents('smart-input').removeClass('error').find('.error').removeClass('error');
		}
	}
	var success = !Nette.formErrors.length;
	Nette.showFormErrors(form, Nette.formErrors);
	return success;
};

Nette.addError = function(elem, message) {
	let $formElement = $(elem);

	if (
		$formElement.attr('type') === 'number'
		&& message === Nette.invalidNumberMessage
		&& $formElement.attr('step') !== undefined
		&& $formElement.attr('data-previous-and-next-step') !== undefined
		&& $formElement.attr('data-previous-step') !== undefined
	) {
		let previousValue = ($formElement.attr('min') * 1) + Math.round(Math.floor(Math.round(($formElement.val() - ($formElement.attr('min') * 1)) / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;
		let nextValue = ($formElement.attr('min') * 1) + Math.round(Math.ceil(Math.round(($formElement.val() - ($formElement.attr('min') * 1)) / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;

		if (($formElement.attr('min') * 1) > previousValue) {
			previousValue = ($formElement.attr('min') * 1);
		}

		if (($formElement.attr('max') * 1) < nextValue) {
			nextValue = ($formElement.attr('min') * 1) + Math.round(Math.floor(Math.round((($formElement.attr('max') * 1) - ($formElement.attr('min') * 1)) / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;
		}

		if (previousValue < nextValue) {
			message = $formElement.attr('data-previous-and-next-step')
				.replace('%previousValue%', previousValue)
				.replace('%nextValue%', nextValue);
		}
		else {
			message = $formElement.attr('data-previous-step').replace('%previousValue%', previousValue);
		}
	}

	$formElement.addClass('error');
	$formElement.data('error-message', message);

	let $smartInput             = $formElement.parents('smart-input').addClass('error');
	let $smartInputErrorMessage = $smartInput.find('smart-input-error-message');

	// Fix for radio list and checkbox list
	$smartInput.find('input[type=radio], input[type=checkbox]').addClass('error');

	if ($smartInputErrorMessage.length) {
		$smartInputErrorMessage.text(message);
	}
	else {
		$smartInput.append($('<smart-input-error-message>').text(message));
	}

	Nette.formErrors.push({
		element: elem,
		message: message
	});
};

Nette.showFormErrors = function(form, errors) {
	if (errors.length === 0) {
		let $form = $(form);

		$form.find('smart-input-error-message').remove();
		$form.find('[data-error-message]').removeAttr();
		$form.find('.error').removeClass('error');

		return;
	}

	let $formElement = $(errors[0].element);

	if ($formElement.attr('type') === 'radio') {
		$('input[name="' + $formElement.attr('name') + '"]:not(:disabled)').first().focus();
	}
	else if (errors[0].element.tomselect) {
		errors[0].element.tomselect.open();
	}
	else {
		$formElement.focus();
	}

	$.flashMessenger.createFlashMessage(errors[0].message, 'error', 5000);
};

Nette.toggle = function(selector, visible, srcElement, event) {
	if (/^\w[\w.:-]*$/.test(selector)) { // id
		selector = '#' + selector;
	}

	let refreshToggle = false;

	Array.from(document.querySelectorAll(selector))
		.forEach((elem) => {
			if ($(elem).is('[hidden]') === false && !visible) {
				$(elem).find("select, textarea, input:not([type=\"radio\"]):not([type=\"checkbox\"]):not([type=\"submit\"]):not([type=\"button\"])").each(function () {
					const $this = $(this);

					// A partly typed date reads as '' but still counts as filled for its own triggers (DEVDV-677).
					if ($this.is('[data-filled]') === true || $this.val() !== "" || (this.type === 'date' && this.validity.badInput)) {
						$this.removeAttr('data-filled').val("").trigger('change');
					}
				});
				$(elem).find("input[type=\"radio\"], input[type=\"checkbox\"]").each(function () {
					const $this = $(this);

					if ($this.prop("checked") === true) {
						$this.prop("checked", false).trigger('change');
					}
				});
				$(elem).find("smart-file").remove();

				refreshToggle = true;
			}

			elem.hidden = !visible;
		});

	if (refreshToggle === true) {
		Nette.toggleForm($(selector).parents('form')[0]);
	}
};

// A partly typed date fails its own min/max rules, which made netteForms hide its "filled" targets and
// Nette.toggle empty them (DEVDV-677); evaluate only its conditions while it is partly typed.
const originalToggleControl = Nette.toggleControl;

Nette.toggleControl = function(elem, rules, ...args) {
	if (rules == null && elem.type === 'date' && elem.validity.badInput) {
		rules = JSON.parse(elem.getAttribute('data-nette-rules') ?? '[]').filter((rule) => rule.rules);
	}

	return originalToggleControl.call(this, elem, rules, ...args);
};

// A date picker's text field has no rules of its own: a valid one (empty or a committed date) is judged by the native
// input behind it, so leaving an empty required date keeps its error; an incomplete entry keeps the picker's own
// message (D11, DEVDV-684).
const originalValidateControl = Nette.validateControl;

Nette.validateControl = function(elem, ...args) {
	const native = elem instanceof HTMLInputElement && elem.dataset.dateProxy && elem.validity.valid
		? document.getElementById(elem.dataset.dateProxy) ?? elem
		: elem;

	return originalValidateControl.call(this, native, ...args);
};

// Clearing a partly typed date fires no input/change (its value stays ''), so re-run the toggles once it is
// really empty (DEVDV-677); focusout covers the picker's Clear button.
['keyup', 'focusout'].forEach((type) => document.addEventListener(type, (event) => {
	const elem = event.target;

	if (elem.type !== 'date' || !elem.form || elem.value !== '' || elem.validity.badInput) {
		return;
	}

	Nette.toggleForm(elem.form, event);
}));

// Checkbox-list trigger: "contains" semantics (unlike native equal's all-match on arrays)
Nette.validators['AppFormsValidator_validateContains'] = (elem, args, val) => {
	return Array.isArray(val)
		? val.map(String).includes(String(args))
		: String(val) === String(args);
};

Nette.validators['AppFormsValidator_validateNotContains'] = (elem, args, val) => {
	return !Nette.validators['AppFormsValidator_validateContains'](elem, args, val);
};

// Image preview
if (typeof $ === 'function') {
	$('label.file-preview').each(function () {
		$(`#${$(this).attr('for')}`).change(function (event) {
			let $filePreview = $(`label.file-preview[for=${$(this).attr('id')}]`);

			$filePreview.children('picture, img').remove();

			if (event.target.files.length > 0) {
				let file = new File([event.target.files[0]], event.target.files[0].name);
				let $image = $('<img>');
				$image.attr('src', URL.createObjectURL(file));
				$filePreview.prepend($image);
				$filePreview.find('span').css('z-index', -1);
			}
			else {
				$filePreview.parents('smart-input').find('input[type=hidden], input[type=file]').val('');
			}
		});
	}).hover(function () {
		$(this).find('span').css('z-index', 2);
	});
}

$(document).ready(function(){
	let revalidateAllErrorInputs = function ($form) {
		$form.find('smart-input input.error, smart-input select.error, smart-input textarea.error').each(function () {
			validateControl($(this), 0);
		});
	};

	let validateControl = function ($element, delay = 250) {
		clearTimeout(Nette.validateControlTimer[$element.attr('id')]);

		Nette.validateControlTimer[$element.attr('id')] = setTimeout(function () {
			if (Nette.validateControl($element[0])) {
				$element.parents('smart-input').find('[data-error-message]').removeAttr();
				$element.parents('smart-input').find('smart-input-error-message').remove();
				$element.parents('smart-input').removeClass('error').find('.error').removeClass('error');

				revalidateAllErrorInputs($element.parents('form'));
			}
		}, delay);
	};

	$('smart-input-eye-control').click(function () {
		let $input = $(this).parents('smart-input').find('input[type=text], input[type=password]');

		if ($input.attr('type') === 'password') {
			$input.attr('type', 'text');
		}
		else {
			$input.attr('type', 'password');
		}
	});

	$('smart-input-clear-image-control').click(function (event) {
		event.stopPropagation();
		event.preventDefault();

		if (confirm($(this).data('clear-confirm'))) {
			let $smartInput = $(this).parents('smart-input');
			$smartInput.find('label > img, label > picture').remove();
			$smartInput.find('input[type=hidden], input[type=file]').val('');
		}
	});

	// Smart input file
	$('smart-input input[type=file]').on('change', function () {
		const $this = $(this);
		const $form = $this.parents('form');
		const $filled = $this.parents('smart-input').find('input[type=checkbox][data-check-is-filled]');
		const checked = $this.val() || $this.is('[data-filled]') === true;

		if ($filled.length > 0 && $filled.prop('checked') !== checked) {
			$filled.prop('checked', checked).trigger('change');

			// Refresh nette toggle triggers
			Nette.toggleForm($form[0]);
		}
	});

	$('label, smart-input-eye-control, smart-input-clear-image-control').on('selectstart', function () {return false;});

	$(document).on('keydown', 'input[type!=radio], input[type!=checkbox], textarea', function(){
		clearTimeout(Nette.validateControlTimer[$(this).attr('id')]);
	});

	$(document).on('keyup', 'input[type!=submit], textarea, select', function (event) {
		let keyCode = event.which || event.keyCode;

		if ($(this).parents('.ts-control').length > 0) {
			return;
		}

		if (keyCode === 13) {
			$(this).addClass('blured');
		}
	});

	$(document).on('keyup', 'input.blured, textarea.blured, input.error, textarea.error', function(){
		validateControl($(this));
	});

	$(document).on('blur', 'input[type=text], input[type=password], input[type=number], input[type=email], input[type=url], input[type=date], input[type=datetime-local], textarea', function(){
		let $this = $(this);

		if ($(this).parents('.ts-control').length > 0) {
			return;
		}

		$this.addClass('blured');
		validateControl($this);
	});

	$(document).on('blur, change', 'select, input[type=file]', function(){
		validateControl($(this));
	});

	$(document).on('blur, change, click', 'input[type=radio], input[type=checkbox]', function() {
		validateControl($(this));
	});

	// Double-submit guard
	$(document).on('submit', 'form', function (event) {
		// nette-forms listener on the form runs first; when validation fails the form is not submitting
		if (event.isDefaultPrevented()) {
			return;
		}

		if (this.dataset.submitting === 'true') {
			event.preventDefault();
			return;
		}

		this.dataset.submitting = 'true';

		let $form = $(this);

		// Disabling synchronously would exclude the submit button value from POST data
		setTimeout(function () {
			$form.find('input[type=submit], button[type=submit]').prop('disabled', true);
		}, 0);
	});

	// Safari/iOS restores the page from bfcache on back navigation, including the disabled state
	$(window).on('pageshow', function () {
		$('form[data-submitting]').removeAttr('data-submitting')
			.find('input[type=submit], button[type=submit]').prop('disabled', false);
	});
});
